import { render, staticRenderFns } from "./ContactActivity.vue?vue&type=template&id=916c1eb4&scoped=true&"
import script from "./ContactActivity.vue?vue&type=script&lang=js&"
export * from "./ContactActivity.vue?vue&type=script&lang=js&"
import style0 from "./ContactActivity.vue?vue&type=style&index=0&id=916c1eb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916c1eb4",
  null
  
)

export default component.exports